/*
* Collect in array error code which depands to one specific field in order to better do validation and keep track for all related codes
* NOTE: all code description you can react in english.js file (translation)
* All this errors goes from server and in server it is listed as well
* */
export const ERROR_CODES_RELATED_TO_EMAIL = [57, 54];

export const ERROR_CODES_RELATED_TO_PASS = [58];
